export default __webpack_public_path__ + "static/media/logo.9cb12a5b.png";